import type { StackProps } from '@mui/material';

import {
  Link,
  Section,
  NameBanner,
  CustomizedAccordion,
} from '@rumblefish/ui/Rumblefish23Theme';

import {
  AccordionData,
  blockchainServicesData,
} from './BlockchainServices.data';
import {
  MainText,
  StyledStack,
  StyledButton,
  DescriptionText,
  StyledTextStack,
  StyledLinkWrapper,
  StyledContentStack,
  StyledAccordionStack,
} from './styles';

export const BlockchainServices = ({
  ...props
}: StackProps): React.ReactElement => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <NameBanner type="section" text="Services" color="cyan" />
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">
              {blockchainServicesData.mainText}
            </MainText>
            <DescriptionText variant="strong_400">
              {blockchainServicesData.description}
            </DescriptionText>
          </StyledTextStack>
          <StyledAccordionStack>
            <CustomizedAccordion
              data={AccordionData()}
              CustomButton={
                <StyledLinkWrapper>
                  <Link to="/contact">
                    <StyledButton>Book a free consultation</StyledButton>
                  </Link>
                </StyledLinkWrapper>
              }
            />
          </StyledAccordionStack>
        </StyledContentStack>
      </StyledStack>
    </Section>
  );
};
